import { QrCode, CreditCard, Barcode, Lock, ShieldCheck } from "lucide-react";

const METHODS = [
  { icon: QrCode, title: "Pix", highlight: true, desc: "Desconto especial e aprovação imediata. Processamento prioritário do seu pedido.", tag: "Mais rápido" },
  { icon: CreditCard, title: "Cartão de Crédito", desc: "Parcele em até 12x no cartão. Praticidade para caber no seu orçamento.", tag: "Até 12x" },
  { icon: Barcode, title: "Boleto Bancário", desc: "Emissão rápida com vencimento em até 3 dias úteis. Compensação em 1 dia útil.", tag: "Tradicional" },
];

export default function PaymentSection() {
  return (
    <section id="pagamento" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-semibold tracking-wider uppercase text-emerald-600 mb-3">Pagamento Seguro</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight">
            Pague do seu jeito, com total segurança
          </h2>
          <p className="mt-4 text-lg text-slate-600">Escolha a forma de pagamento que melhor se encaixa na sua necessidade.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-7">
          {METHODS.map((m) => (
            <div
              key={m.title}
              data-testid={`payment-method-${m.title.toLowerCase().replace(/\s/g, "-")}`}
              className={`relative rounded-2xl p-7 border transition-all duration-300 hover:-translate-y-1 ${
                m.highlight ? "border-emerald-500 bg-emerald-50 shadow-[0_0_25px_rgba(16,185,129,0.15)]" : "border-slate-200 bg-slate-50 hover:shadow-lg"
              }`}
            >
              <span className={`absolute top-5 right-5 rounded-full px-2.5 py-1 text-xs font-bold ${m.highlight ? "bg-emerald-600 text-white" : "bg-slate-200 text-slate-600"}`}>{m.tag}</span>
              <span className={`grid place-items-center h-14 w-14 rounded-2xl mb-5 ${m.highlight ? "bg-emerald-600 text-white" : "bg-white text-[#0F294A] border border-slate-200"}`}>
                <m.icon className="h-7 w-7" />
              </span>
              <h3 className="font-heading font-bold text-xl text-slate-900">{m.title}</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-slate-500">
          <span className="inline-flex items-center gap-2 text-sm font-medium"><Lock className="h-4 w-4 text-emerald-600" /> Criptografia SSL 256-bit</span>
          <span className="inline-flex items-center gap-2 text-sm font-medium"><ShieldCheck className="h-4 w-4 text-emerald-600" /> Ambiente de pagamento seguro</span>
          <span className="inline-flex items-center gap-2 text-sm font-medium"><CreditCard className="h-4 w-4 text-emerald-600" /> Processado via Stripe</span>
        </div>
      </div>
    </section>
  );
}
